import * as React from 'react';

import './Loader.css';

export class Loader extends React.Component<{}> {
    render() {
        return (<div className="three-bounce fade-in sk-spinner">
            <div className="bounce1"></div>
            <div className="bounce2"></div>
            <div className="bounce3"></div>
        </div>);
    }
}
